var jade = require("/home/romain/Cozy/cozy-proxy/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (cguLink, figureid, figures, id, link, t, undefined) {
buf.push("<div class=\"main-wrapper\"><header>");
if ( figureid)
{
buf.push("<figure" + (jade.attr("id", id, true, true)) + ">");
if ( link)
{
buf.push("<a" + (jade.attr("href", link, true, true)) + " target=\"_blank\"><svg><use" + (jade.attr("xlink:href", figureid, true, true)) + "></use></svg></a>");
}
else
{
buf.push("<div class=\"svg-wrapper\"><svg><use" + (jade.attr("xlink:href", figureid, true, true)) + "></use></svg></div>");
}
buf.push("</figure>");
}
buf.push("<h1>" + (jade.escape(null == (jade_interp = t('step agreement title')) ? "" : jade_interp)) + "</h1><p>" + (jade.escape(null == (jade_interp = t('step agreement subtitle')) ? "" : jade_interp)) + "</p></header><div role=\"region\"><div class=\"agreements\">");
// iterate figures
;(function(){
  var $$obj = figures;
  if ('number' == typeof $$obj.length) {

    for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
      var figure = $$obj[index];

buf.push("<div class=\"agreements-element\"><figure" + (jade.attr("id", 'figure'+index, true, true)) + "><div class=\"svg-wrapper\"><svg><use" + (jade.attr("xlink:href", figure, true, true)) + "></use></svg></div></figure><p>" + (jade.escape(null == (jade_interp = t('step agreement element ' + index)) ? "" : jade_interp)) + "</p></div>");
    }

  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;      var figure = $$obj[index];

buf.push("<div class=\"agreements-element\"><figure" + (jade.attr("id", 'figure'+index, true, true)) + "><div class=\"svg-wrapper\"><svg><use" + (jade.attr("xlink:href", figure, true, true)) + "></use></svg></div></figure><p>" + (jade.escape(null == (jade_interp = t('step agreement element ' + index)) ? "" : jade_interp)) + "</p></div>");
    }

  }
}).call(this);

buf.push("</div><div class=\"stats-agreement\"><div class=\"checkbox\"><input type=\"checkbox\" checked></div><p>" + (jade.escape(null == (jade_interp = t('step agreement stats')) ? "" : jade_interp)) + "</p></div><p><span>" + (jade.escape(null == (jade_interp = (t('step agreement description 1') + ' ')) ? "" : jade_interp)) + "</span><a" + (jade.attr("href", cguLink, true, true)) + " target=\"_blank\">" + (jade.escape(null == (jade_interp = t('step agreement description link')) ? "" : jade_interp)) + "</a><span>" + (jade.escape(null == (jade_interp = (' ' + t('step agreement description 2'))) ? "" : jade_interp)) + "</span></p><p class=\"errors\"></p></div><footer><div class=\"controls\"><button class=\"next\">" + (jade.escape(null == (jade_interp = t('step agreement next')) ? "" : jade_interp)) + "</button></div><div class=\"progression\"></div></footer></div>");}.call(this,"cguLink" in locals_for_with?locals_for_with.cguLink:typeof cguLink!=="undefined"?cguLink:undefined,"figureid" in locals_for_with?locals_for_with.figureid:typeof figureid!=="undefined"?figureid:undefined,"figures" in locals_for_with?locals_for_with.figures:typeof figures!=="undefined"?figures:undefined,"id" in locals_for_with?locals_for_with.id:typeof id!=="undefined"?id:undefined,"link" in locals_for_with?locals_for_with.link:typeof link!=="undefined"?link:undefined,"t" in locals_for_with?locals_for_with.t:typeof t!=="undefined"?t:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/views/templates/view_steps_agreement.jade
// module id = 21
// module chunks = 0